function tryParseJson(value) {
  if (typeof value !== "string") {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
}

function firstArrayValue(obj) {
  if (!obj || typeof obj !== "object") {
    return [];
  }

  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    var value = obj[keys[i]];
    if (Array.isArray(value)) {
      return value;
    }
  }

  return [];
}

export function normalizeResponseArray(response) {
  if (!response) {
    return [];
  }

  var body = tryParseJson(response.body);
  if (Array.isArray(body)) {
    return body;
  }

  if (body && typeof body === "object") {
    var nestedArray = firstArrayValue(body);
    if (nestedArray.length > 0) {
      return nestedArray;
    }
  }

  var data = tryParseJson(response.data);
  if (Array.isArray(data)) {
    return data;
  }

  if (data && typeof data === "object") {
    return firstArrayValue(data);
  }

  return [];
}



// WEBPACK FOOTER //
// ./src/utils/responseNormalizer.js